export default "__VITE_ASSET__CyMvE6eM__"